import styled from '@emotion/styled';
import { COLORS, FONT, SPACING } from '../../../styles/emotion';
import Remove from '../../SvgIcons/Remove';

export const ErrorContainer = styled.span`
  display: flex;
  font-size: ${FONT.FONT_SIZE_EXTRA_SMALL};
`;

export const ErrorCopy = styled.span`
  .zola-ui span& {
    color: ${COLORS.SHIRAZ_RED};
    margin-top: 2px;
    line-height: 16px;
  }
`;

export const ErrorIcon = styled(Remove)`
  margin-right: ${SPACING.XXS};
  position: relative;
  top: 5px;
  fill: ${COLORS.SHIRAZ_RED};
  flex-shrink: 0;
`;
